import React, { Suspense } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { Typography } from '@mui/material';
import { Loading, useInjectedComponent } from '@cnx-saas/common-fe';

export function CurrentTransports() {
  const ShipmentStatusCountWidget = useInjectedComponent(
    'shipmentExecution/CurrentTransportsWidget',
  );

  return (
    <ErrorBoundary
      fallback={
        <Typography variant="h6" padding={2}>
          Error loading component
        </Typography>
      }
    >
      <Suspense fallback={<Loading />}>
        {ShipmentStatusCountWidget && <ShipmentStatusCountWidget />}
      </Suspense>
    </ErrorBoundary>
  );
}
